import websocketActionTypes from "../actionTypes/websocket.actionTypes"
import {WebSocketRequestMessage_Subscription} from "../proto/generated/websocket"
import {AppDispatch} from "../store"


const setWebsocketSubscribeList = (dispatch: AppDispatch, data: Partial<WebSocketRequestMessage_Subscription>) => {
    dispatch({
        type: websocketActionTypes.SET_WEBSOCKET_SUBSCRIBE_LIST,
        payload: {
            candleSubscriptions: [],
            oiCandleSubscriptions: [],
            watchlistSubscriptions: [],
            optionChainSubscriptions: [],
            securitySnapshotSubscriptions: [],
            indexComponentSubscriptions: [],
            orderBookSubscriptions: [],
            ...data
        }
    })
}

const websocketActions = {
    setWebsocketSubscribeList
}

export default websocketActions